import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Button from '../Elements/Button/Button';
import Checkbox from '../Elements/Checkbox/Checkbox';
import Input from '../Elements/Input/Input';
import { subscribeToNewsletter } from '../../actions/checkout';
import { purifier, setCookie } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { fieldValidation, createSha256Hash } from '../../utils/string';
import s from './Newsletter.scss';

const Newsletter = ({ newsletter = {}, setup, callback = false, variant = false, ...props }) => {
	const requiredFields = ['email'];
	const initialState = {
		email: '',
		interest: 'all',
	};
	const [errors, updateErrors] = useState({});
	const [fields, updateFields] = useState(initialState);
	const [sentState, updateSentState] = useState(false);

	const newsletterInputChangeHandler = (id, value) => {
		if (id.indexOf('Newsletter') !== -1) id = id.slice(0, id.indexOf('Newsletter'));

		updateFields((prevState) => ({
			...prevState,
			[id]: value,
		}));

		updateErrors((prevState) => {
			const { [id]: removed, ...nextState } = prevState;
			return nextState;
		});

		updateSentState(false);
	};

	const newsletterInputBlurHandler = (id, value) => {
		id = id.slice(0, id.indexOf('Newsletter'));
		newsletterInputChangeHandler(id, value);

		if (fieldValidation(value, id) && requiredFields.indexOf(id) !== -1) {
			updateErrors((prevState) => ({
				...prevState,
				[id]: translate(setup, `error${fieldValidation(value, id)}`),
			}));
			return true;
		}
		return false;
	};

	const newsletterInterestChangeHandler = (id) => {
		const selectedInterest = id.slice(0, id.indexOf('Newsletter'));
		updateFields((prevState) => ({
			...prevState,
			interest: prevState.interest === selectedInterest ? '' : selectedInterest,
		}));
		updateSentState(false);
	};


	const submitNewsletterHandler = (e) => {
		e.preventDefault();

		let hasErrors = false;
		const $inputs = e.currentTarget.querySelectorAll('input');
		$inputs.forEach(($input) => {
			const id = $input.getAttribute('id');
			const value = $input.value;
			const returnErrors = newsletterInputBlurHandler(id, value);
			if (returnErrors) hasErrors = true;
		});

		if (hasErrors || Object.keys(errors).length > 0) return;

		props.subscribeToNewsletter(fields)
			.then(() => {
				window.setTimeout(() => {
					updateSentState(false);
					updateFields(initialState);
					if (callback) callback();
				}, 3000);

				updateSentState('sent');

				createSha256Hash(fields.email.toLowerCase().trim())
					.then((hash) => {
						setCookie('emailHash', hash, 365);
						return hash;
					})
					.catch(() => console.log('ERROR: unable to create email hash'));

				return true;
			})
			.catch((err) => {
				console.log('DEBUG: err', err);
				updateSentState('error');
				return false;
			});
	};

	return (
		<div className={[s.newsletter, (sentState === 'sent' ? s.newsletter__sent : null), s[`newsletter__${variant}`]].join(' ')}>
			{ variant !== 'popup' && <h6 className={s.newsletter_title}>{ translate(setup, newsletter.title) }</h6> }
			{ variant !== 'popup' && <div className={s.newsletter_intro}>{ translate(setup, newsletter.intro) }</div> }
			<form className={[s.newsletter_form, (sentState === 'error' ? s.newsletter_form__error : null)].join(' ')} onSubmit={submitNewsletterHandler}>
				<div className={s.newsletter_form_interest}>
					<Checkbox variantClasses={['checkbox__newsletter']} id={`womenNewsletter${variant}`} label={translate(setup, 'newsletterWomen')} selected={fields.interest === 'women'} inputChange={newsletterInterestChangeHandler} />
					<Checkbox variantClasses={['checkbox__newsletter']} id={`menNewsletter${variant}`} label={translate(setup, 'newsletterMen')} selected={fields.interest === 'men'} inputChange={newsletterInterestChangeHandler} />
					<Checkbox variantClasses={['checkbox__newsletter']} id={`allNewsletter${variant}`} label={translate(setup, 'newsletterAll')} selected={fields.interest === 'all'} inputChange={newsletterInterestChangeHandler} />
				</div>
				<div className={s.newsletter_form_input}>
					<Input variantClasses={['input__newsletter']} id={`emailNewsletter${variant}`} type="email" isError={errors.email || false} value={fields.email} inputChange={newsletterInputChangeHandler} placeholder={translate(setup, 'labelEmail')} />
					<Button variantClasses={['button__newsletter']} type="submit" text={translate(setup, newsletter.button)} />
				</div>
			</form>
			<span className={s.newsletter_thanks}>{translate(setup, newsletter.thanks)}</span>
			<div className={s.newsletter_terms} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, newsletter.terms)) }} />
		</div>
	);
};

const mapState = ({ environment }, { callback }) => ({ setup: environment.setup, newsletter: environment.newsletter, callback });

export default hot(module)(connect(mapState, { subscribeToNewsletter })(Newsletter));
